import { AppSidebar } from "@/lib/shadcn/components/sidebar";
import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import { demoSidebarItems } from "@/pages/demoSidebar";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/lib/shadcn/ui/sidebar";
import { Badge } from "@/lib/shadcn/ui/badge";
const TABLET_BREAKPOINT = 1024;

function useIsTabletOrSmaller() {
    const [isTabletOrSmaller, setIsTabletOrSmaller] = useState(typeof window !== "undefined" ? window.innerWidth < TABLET_BREAKPOINT : false);

    useEffect(() => {
        const handleResize = () => {
            setIsTabletOrSmaller(window.innerWidth < TABLET_BREAKPOINT);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isTabletOrSmaller;
}

export default function DemoLayout() {
    const isTabletOrSmaller = useIsTabletOrSmaller();

    return (
        <SidebarProvider id={"#sidebar"} defaultOpen={!isTabletOrSmaller}>
            <AppSidebar
                sections={demoSidebarItems}
                user={{
                    name: "Demo",
                    email: "demo@keroshospitality.com",
                    avatar: "",
                }}
            />
            <SidebarInset>
                <header className="flex justify-between h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
                    <div className="flex items-center gap-2 px-4">
                        <SidebarTrigger className="-ml-1" />
                    </div>
                    <div className="mr-7">
                        <Badge variant="outline" className="text-sm px-3 py-1 border-amber-500 text-amber-700 bg-amber-50">
                            DEMO MODE
                        </Badge>
                    </div>
                </header>
                <div className="flex flex-1 flex-col gap-4 p-4 pt-0">
                    <main className="p-1">
                        <Outlet />
                    </main>
                </div>
            </SidebarInset>
        </SidebarProvider>
    );
}
